import moment from 'moment';
import momentTimeZone from 'moment-timezone';
import Logger from '../util/Logger';

/**
 * Generic class
 */
export default {

  /**
   * Given a moment object returns the unix seconds value.
   *
   * @param {moment.Moment} momentObject
   * @return {number} unix seconds
   */
  momentToUnixSeconds (momentObject) {
    if (!momentObject) {
      Logger.assert(`You need to pass a moment object.`);
    }

    if (!moment.isMoment(momentObject)) {
      Logger.assert(`The object passed is not a moment`);
    }

    return momentObject.unix();
  },

  /**
   * Given unix seconds returns a moment object
   *
   * @param unixSeconds
   * @return {moment.Moment} Moment object
   */
  unixSecondsToMoment (unixSeconds) {
    if (unixSeconds === undefined || unixSeconds === null) {
      Logger.assert(`You need to pass unixSeconds.`);
    }

    if (moment.isMoment(unixSeconds)) {
      Logger.assert(`The object passed is a moment`);
    }

    return moment.unix(unixSeconds);
  },

  /**
   * Given a moment object apply a timezone to it
   *
   * @param {moment.Moment} momentObject
   * @param timeZone
   * @return {number} unix seconds
   */
  applyTimeZone (momentObject, timeZone) {
    if (!momentObject) {
      Logger.assert(`You need to pass a moment object.`);
    }

    if (!moment.isMoment(momentObject)) {
      Logger.assert(`The object passed is not a moment`);
    }

    return momentTimeZone(momentObject).tz(timeZone);
  },

  /**
   * Returns time now
   * @returns {moment.Moment}
   */
  now () {
    return moment();
  },

  /**
   * Copies existing object
   * @returns {moment.Moment}
   */
  clone (obj) {
    return moment(obj)
  },

  /**
   * Get a duration of time
   *
   * @param obj
   * @returns {moment.Duration}
   */
  duration (obj) {
    return moment.duration(obj);
  },
  /**
   * Get length of time between two dates
   *
   * @param {moment.Moment} prior date
   * @param {moment.Moment} later date
   * @returns {moment.Duration}
   */
  diffInMinutes (moment1, moment2) {
    return moment2.diff(moment1, 'minutes');
  },

  getCurrentTimeZone () {
    return momentTimeZone.tz.guess();
  },

  fromTimeStamp (stamp) {
    return moment(stamp);
  },

  format (momentObject, formatString, tz = this.getCurrentTimeZone()) {
    if (!momentObject) {
      Logger.assert(`You need to pass a moment object.`);
    }

    if (!moment.isMoment(momentObject)) {
      Logger.assert(`The object passed is not a moment`);
    }

    return this.applyTimeZone(momentObject, tz).format(formatString);
  }
};
